module.exports = __webpack_public_path__ + "static/media/Group-150.43855c86.jpg";